var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.4648 13.2812C26.4648 14.0902 27.1207 14.7461 27.9297 14.7461C28.7387 14.7461 29.3945 14.0902 29.3945 13.2812C29.3945 12.4723 28.7387 11.8164 27.9297 11.8164C27.1207 11.8164 26.4648 12.4723 26.4648 13.2812Z",
    fill: "#B44D2D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3242 13.2812C32.3242 14.0902 32.9801 14.7461 33.7891 14.7461C34.598 14.7461 35.2539 14.0902 35.2539 13.2812C35.2539 12.4723 34.598 11.8164 33.7891 11.8164C32.9801 11.8164 32.3242 12.4723 32.3242 13.2812Z",
    fill: "#B44D2D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1836 13.2812C38.1836 14.0902 38.8395 14.7461 39.6484 14.7461C40.4574 14.7461 41.1133 14.0902 41.1133 13.2812C41.1133 12.4723 40.4574 11.8164 39.6484 11.8164C38.8395 11.8164 38.1836 12.4723 38.1836 13.2812Z",
    fill: "#B44D2D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6771 36.7188L27.0716 33.7891L35.8398 36.7188V42.5781C35.8398 44.1961 34.549 45.5078 32.931 45.5078C16.7508 45.5078 1.46484 30.3195 1.46484 14.1394C1.46484 12.5214 2.77656 11.2305 4.39453 11.2305H10.2539L13.1836 19.9987L10.2539 24.3933C12.1247 29.0703 18 34.8479 22.6771 36.7188Z",
    stroke: "#B44D2D",
    strokeWidth: 1.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1406 13.2812C19.1406 18.1354 23.0756 22.0703 27.9297 22.0703V27.9297L33.7891 22.0703H39.6484C44.5025 22.0703 48.5352 18.1354 48.5352 13.2812C48.5352 8.42715 44.5025 4.49219 39.6484 4.49219H27.9297C23.0756 4.49219 19.1406 8.42715 19.1406 13.2812Z",
    stroke: "#B44D2D",
    strokeWidth: 1.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.8684552960c9f1114f40dd09cf4a7581.svg";
export { ForwardRef as ReactComponent };